import { createNotification } from "../store/reducers/notificationSlice";

/**
 * Dispatch a status-change notification with a consistent payload across all actions.
 * Audience defaults: company admins. Pass extra flags for GB role broadcasts.
 *
 * IMPORTANT: Call only after the primary action succeeded (2xx).
 * Do not call when the action returned 403/404/4xx/5xx — that would still hit
 * /notification and /users/sendMail incorrectly.
 */
export function dispatchStatusNotification(
  dispatch,
  {
    accessToken,
    userId,
    template,
    message,
    subject,
    htmlMailContent,
    is_admin = false,
    sendToCompanyAdmins = true,
    sendToGamingBoardAdmins = false,
    sendToGamingBoardManagers = false,
    sendToGamingBoardReviewers = false,
    sendToGamingBoardViewers = false,
  }
) {
  const resolvedUserId = userId;
  if (!accessToken) {
    console.warn("[applicationNotify] skipped: missing accessToken");
    return null;
  }
  if (resolvedUserId == null || resolvedUserId === "") {
    console.warn("[applicationNotify] skipped: missing userId");
    return null;
  }

  return dispatch(
    createNotification({
      accessToken,
      userId: resolvedUserId,
      message: template?.message ?? message,
      subject: template?.subject ?? subject,
      htmlMailContent: template?.html ?? htmlMailContent,
      is_admin,
      sendToCompanyAdmins,
      sendToGamingBoardAdmins,
      sendToGamingBoardManagers,
      sendToGamingBoardReviewers,
      sendToGamingBoardViewers,
    })
  );
}

/** Broadcast to all GB portal roles + company admins (discrepancy / assign flows). */
export const GB_BROADCAST_FLAGS = {
  sendToCompanyAdmins: true,
  sendToGamingBoardAdmins: true,
  sendToGamingBoardManagers: true,
  sendToGamingBoardReviewers: true,
  sendToGamingBoardViewers: true,
};
